export default __webpack_public_path__ + "static/media/warning.5336a29e.svg";